import { ArrowLeftOutlined } from '@ant-design/icons'
import { Button, PageHeader, Space } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useBack } from '@/hooks/useBack'

const CreateDetergentHistoryPageHeader = () => {
  const { t } = useTranslation()
  const handleBack = useBack()
  return (
    <Space>
      <Button onClick={handleBack} icon={<ArrowLeftOutlined />}></Button>
      <PageHeader ghost={false} title={t('components.pages.detergentHistories.create.pageHeader.title')} />
    </Space>
  )
}

CreateDetergentHistoryPageHeader.displayName = 'CreateDetergentHistoryPageHeader'
export default CreateDetergentHistoryPageHeader
